const changeQty = (action, id, el) => {
    let qty_input = document.querySelector(`.qty_input-${id}`);

    if (action === "plus") {
        qty_input.value === ++qty_input.value;
    } else if (action === "minus") {
        +qty_input.value !== 1 && qty_input.value === --qty_input.value;
    }
};
const outsideClick = () => {
    const specifiedElementDiscount = document.getElementById("custom_popup");
    const specifiedElementPurchase = document.getElementById("custom_popup_purchase");
    document.addEventListener("click", (event) => {
        if (event.target.id === specifiedElementDiscount?.id) {
            closePopup();
        }
        if (event.target.id === specifiedElementPurchase?.id) {
            closePopup('purchase');
        }
    });
};
const closePopup = (method) => {
    if (method === "purchase") {
        document
            .querySelector(".purchase_popup_wrapper")
            .classList.add("popup_disabled");
    } else {
        document
            .querySelector(".custom_discount_popup_wrapper")
            .classList.add("popup_disabled");
        setDateForNextDisplaying();
    }
    document.querySelector("body").style.overflow = "scroll";
    document.querySelector("html").style.overflow = "scroll";
};
const setDateForNextDisplaying = () => {
    let settings_delay_days = "{{ settings.discount_popup_days_delay }}";

    let currentDate = new Date();

    let displaying_date = new Date(
        currentDate.getTime() + settings_delay_days * 24 * 60 * 60 * 1000
    );

    let expires = new Date(displaying_date).toUTCString();

    document.cookie =
        "discount_displaying_date" +
        "=" +
        encodeURIComponent("discount_displaying_date") +
        "; expires=" +
        expires +
        "; path=/";
    // document.querySelector('#cart-icon-bubble').click()
    // fetchCartSnippet()
};

const handleAddTocart = (id) => {
    let qty_input = document.querySelector(`.qty_input-${id}`)?.value || 1;
    
    // Use unified cart utility
    window.CartUtils.addToCart({
        id: +id,
        quantity: +qty_input,
        context: 'discount-popup',
        onSuccess: (data) => {
            successResponse(id);
        },
        onError: (errorData) => {
            handleError(errorData.description);
        }
    });
};

const handleUpdateCartDrawer = () => {
    fetch("/cart")
        .then(response => {
            return response.text();
        })
        .then(data => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(data, "text/html");
            const cartDrawer = doc.querySelector("#CartDrawer");
            const cartBubble = doc.querySelector('#cart-icon-bubble');
            document.querySelector("#CartDrawer").innerHTML = cartDrawer.innerHTML;
            document.querySelector('#cart-icon-bubble').innerHTML = cartBubble.innerHTML;
            body.classList.add('overflow-hidden');
            document.querySelector("cart-drawer").classList.remove('is-empty');
            document.querySelector("cart-drawer").classList.add('animate');
            document.querySelector("cart-drawer").classList.add('active');
        })
        .catch(error => {
            console.error("Error:", error);
        });
};

const handleError = (message) => {
    document.querySelector(".popup_error_container").innerHTML = message;
};
const successResponse = (id) => {
    let product_add_button = document.querySelector(
        `#popup_product_id-${id} .add_to_cart`
    );

    document.querySelector(".popup_error_container").innerHTML = "";

    product_add_button.innerHTML = "Added";
    product_add_button.classList.add("product_added");
    product_add_button.setAttribute("disabled", "");
    setTimeout(() => {
        product_add_button.innerHTML = "Quick Add";
        product_add_button.classList.remove("product_added");
        product_add_button.removeAttribute("disabled");
    }, 2000);

    handleUpdateCartDrawer();
};
